import Store from '../../store';
import Http from "../../http/client";

export default async () => {
  const profile = await Http.get('profile');
  Store.commit('SetProfile', profile.data);
}
